import React, { useState } from 'react'
import { Modal, Col, Form, Row, Button } from 'react-bootstrap'
import { Alert } from 'react-bootstrap'
import { getErrorMessageFromApiResponse } from '../../utils/api/apiUtils'
import useStores from "../../stores/useStore";
import instMgmtApi from '../../utils/api/instanceMgmt/instMgmtApi'
import { ButtonWithLoadingState } from '../Buttons'
import styled from 'styled-components'
import { t } from 'i18next'
const StyledButtonsWrapper = styled.div`
    .btn {
        margin: 4px;
    }
    display: flex;
    width: 100%;
    justify-content: space-between;
    
    @media screen and (max-width: 767px) {
        flex-direction: column;
        width: 100%;
    }
`
const DisposalModal = ({ handleClose, scanCodeObj }) => {
    const { washStore, uiStore } = useStores()
    const [reorder, setReorder] = useState(scanCodeObj.automaticReorder)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const disposed = async () => {
        try {
            setLoading(true)
            let params = {
                action: 'disposed',
                reorder: reorder,
                stationId: washStore.selectedWashStationId
            }
            await instMgmtApi.postScanCodeAction(scanCodeObj.rfid, params)
            if(reorder)
            {
                uiStore.fetchNewShoppingCarts()
            }
            handleClose(true)
        }
        catch (e) {
            setError(getErrorMessageFromApiResponse(e))
        }
        finally {
            setLoading(false)
        }
    }

    return (
        <Modal centered show={true} onHide={handleClose} backdrop='static'>
            <Modal.Header closeButton={handleClose}>
                <Modal.Title >{t('washPage:disposalTitle')}</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <Form>
                    <>{t('washPage:disposalBody')}<br /><br /></>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column>{t('inventory:scanCode')}:</Form.Label>
                        <Col>
                            <div>{scanCodeObj.rfid}</div>
                        </Col>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Check
                            type='checkbox'
                            id='reorder'
                            name='reorder'
                            label={t('washPage:reorder')}
                            checked={reorder}
                            onChange={(e) => setReorder(e.target.checked)}
                        />
                    </Form.Group>
                </Form>
                {error ? <Alert variant="danger">{error}</Alert> : null}
            </Modal.Body >
            <Modal.Footer className="justify-content-start">
                <StyledButtonsWrapper>
                    <ButtonWithLoadingState
                        buttonText={t('inventory:confirm')}
                        loadingText={t('inventory:confirm')}
                        type="submit"
                        form="my-form"
                        loading={loading}
                        disabled={loading}
                        onClick={disposed}
                    />
                    <Button variant="secondary" onClick={() => handleClose(false)}>{t('cancelButton')}</Button>
                </StyledButtonsWrapper>
            </Modal.Footer>
        </Modal>
    )
}

export default DisposalModal